import { ethers } from "ethers";
import { useEffect, useState } from "react";

import {
  fetchAllCustodianManagers,
  fetchAllDpAndCustodianManagers,
} from "../services/subraphs/walletSubraph";
import { getClientContractWeb3 } from "../services/contracts/clientContract";
import useNetworkStore from "../store/networkStore";
import { chainDetails } from "../utils/config";

export const useGetDpAndCustodianDetails = (countries) => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { chainId } = useNetworkStore();

  useEffect(() => {
    const fetchAndFormatManagers = async () => {
      setLoading(true);
      setError(null);
      try {
        const managers = await fetchAllDpAndCustodianManagers(chainId).then(
          (res) => res,
        );
        if (managers.length) {
          let dpCountries = [];
          let dps = [];
          let custodians = [];
          let custodianCountries = [];
          // eslint-disable-next-line array-callback-return
          managers.map((mng) => {
            if (Number(mng?.submanager?.status) === 3) {
              const role = ethers.utils.parseBytes32String(mng.role);
              if (role.toLowerCase() === "dp") {
                const countryCode = ethers.utils.parseBytes32String(
                  mng.country,
                );
                const countryDetails = countries[countryCode.toUpperCase()];
                if (!dpCountries.includes(countryDetails.countryName)) {
                  dpCountries.push(countryDetails.countryName);
                }
                dps.push({
                  name: ethers.utils.parseBytes32String(mng.submanager.name),
                  address: mng.id,
                  country: countryDetails.countryName,
                  countryCode,
                  role,
                });
              }
              if (role.toLowerCase() === "custodian") {
                const countryCode = ethers.utils.parseBytes32String(
                  mng.country,
                );
                const countryDetails = countries[countryCode.toUpperCase()];
                if (!custodianCountries.includes(countryDetails.countryName)) {
                  custodianCountries.push(countryDetails.countryName);
                }
                custodians.push({
                  name: ethers.utils.parseBytes32String(mng.submanager.name),
                  address: mng.id,
                  country: countryDetails.countryName,
                  countryCode,
                  role,
                });
              }
            }
          });

          setData({
            dps,
            custodians,
            dpCountries,
            custodianCountries,
          });
        }
      } catch (err) {
        console.error("Error while fetching all managers: ", err);
        setError(
          err.message || "Error while fetching all managers. Try again later.",
        );
      } finally {
        setLoading(false);
      }
    };

    if (Object.keys(countries).length >= 100) {
      //atleast 100 countries ??
      fetchAndFormatManagers();
    }
  }, [chainId, countries]);

  return {
    getDpAndCustodianDetailsData: data,
    getDpAndCustodianDetailsLoading: loading,
    getDpAndCustodianDetailsError: error,
  };
};

export const useGetCustodianDetails = (
  countries,
  currencySymbol,
  filterCustodianAddress,
  filterCountry,
) => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { chainId, web3 } = useNetworkStore();

  useEffect(() => {
    const fetchAndFormatManagers = async () => {
      setLoading(true);
      setError(null);
      try {
        if (currencySymbol !== "") {
          const managers = await fetchAllCustodianManagers(chainId).then(
            (res) => res,
          );
          if (managers.length) {
            let custodians = [];
            let custodianCountries = [];
            // eslint-disable-next-line array-callback-return
            await Promise.all(
              managers.map(async (mng) => {
                if (Number(mng?.submanager?.status) === 3) {
                  if (filterCountry) {
                    if (
                      filterCountry?.toUpperCase() ===
                        ethers.utils
                          .parseBytes32String(mng.country)
                          ?.toUpperCase() ||
                      currencySymbol?.toLowerCase() === "usdc"
                    ) {
                      const clientContract = getClientContractWeb3(
                        chainId,
                        web3,
                      );
                      const custodyAccounts = await clientContract.methods
                        .getCustodyAccount(mng.id)
                        .call({ from: mng.id });

                      console.log("custodyAccounts: ", custodyAccounts);

                      const currencyDetails =
                        currencySymbol?.toLowerCase()?.startsWith("vc") &&
                        filterCustodianAddress?.length > 0
                          ? custodyAccounts.find(
                              (bnk) =>
                                mng?.id?.toLowerCase() ===
                                  chainDetails[
                                    chainId
                                  ]?.spotCustodian?.toLowerCase() &&
                                "vc" +
                                  ethers.utils
                                    .parseBytes32String(bnk?.currency)
                                    ?.toLowerCase()
                                    .split("-")[1] ===
                                  currencySymbol?.toLowerCase(),
                            )
                          : currencySymbol?.toLowerCase()?.startsWith("vc") &&
                              filterCustodianAddress === ""
                            ? custodyAccounts.find(
                                (bnk) =>
                                  ("vc" +
                                    ethers.utils
                                      .parseBytes32String(bnk?.currency)
                                      ?.toLowerCase()
                                      .split("-")[1] ===
                                    currencySymbol?.toLowerCase()) ===
                                  currencySymbol?.toLowerCase(),
                              )
                            : currencySymbol?.toLowerCase() === "usdc"
                              ? custodyAccounts.find(
                                  (bnk) =>
                                    mng?.id?.toLowerCase() ===
                                      chainDetails[
                                        chainId
                                      ]?.spotCustodian?.toLowerCase() &&
                                    ethers.utils
                                      .parseBytes32String(bnk?.currency)
                                      ?.toLowerCase()
                                      ?.includes("usd"),
                                )
                              : filterCustodianAddress?.length > 0
                                ? custodyAccounts.find(
                                    (bnk) =>
                                      mng?.id?.toLowerCase() ===
                                        chainDetails[
                                          chainId
                                        ]?.spotCustodian?.toLowerCase() &&
                                      ethers.utils
                                        .parseBytes32String(bnk?.currency)
                                        ?.toLowerCase() ===
                                        currencySymbol?.toLowerCase(),
                                  )
                                : filterCustodianAddress?.length > 0 &&
                                    currencySymbol
                                      ?.toLowerCase()
                                      ?.startsWith("-")
                                  ? custodyAccounts.find(
                                      (bnk) =>
                                        mng?.id?.toLowerCase() ===
                                          chainDetails[
                                            chainId
                                          ]?.spotCustodian?.toLowerCase() &&
                                        ethers.utils
                                          .parseBytes32String(bnk?.currency)
                                          ?.toLowerCase()
                                          ?.includes(
                                            currencySymbol
                                              ?.toLowerCase()
                                              ?.replace("-", ""),
                                          ),
                                    )
                                  : custodyAccounts.find(
                                      (bnk) =>
                                        ethers.utils
                                          .parseBytes32String(bnk?.currency)
                                          ?.toLowerCase() ===
                                        currencySymbol?.toLowerCase(),
                                    );
                      if (currencyDetails) {
                        const role = ethers.utils.parseBytes32String(mng.role);
                        if (role.toLowerCase() === "custodian") {
                          const countryCode = ethers.utils.parseBytes32String(
                            mng.country,
                          );
                          const countryDetails =
                            countries[countryCode.toUpperCase()];
                          if (
                            !custodianCountries.includes(
                              countryDetails.countryName,
                            )
                          ) {
                            custodianCountries.push(countryDetails.countryName);
                          }
                          custodians.push({
                            accountId: ethers.utils.parseBytes32String(
                              currencyDetails?.account,
                            ),
                            name: ethers.utils.parseBytes32String(
                              mng.submanager.name,
                            ),
                            address: mng.id,
                            country: countryDetails.countryName,
                            countryCode,
                            role,
                          });
                        }
                      } else {
                        return [];
                      }
                    }
                  } else {
                    const clientContract = getClientContractWeb3(chainId, web3);
                    const custodyAccounts = await clientContract.methods
                      .getCustodyAccount(mng.id)
                      .call({ from: mng.id });

                    console.log("custodyAccounts: ", custodyAccounts);

                    const currencyDetails =
                      currencySymbol?.toLowerCase()?.startsWith("vc") &&
                      filterCustodianAddress?.length > 0
                        ? custodyAccounts.find(
                            (bnk) =>
                              mng?.id?.toLowerCase() ===
                                chainDetails[
                                  chainId
                                ]?.spotCustodian?.toLowerCase() &&
                              "vc" +
                                ethers.utils
                                  .parseBytes32String(bnk?.currency)
                                  ?.toLowerCase()
                                  .split("-")[1] ===
                                currencySymbol?.toLowerCase(),
                          )
                        : currencySymbol?.toLowerCase()?.startsWith("vc") &&
                            filterCustodianAddress === ""
                          ? custodyAccounts.find(
                              (bnk) =>
                                ("vc" +
                                  ethers.utils
                                    .parseBytes32String(bnk?.currency)
                                    ?.toLowerCase()
                                    .split("-")[1] ===
                                  currencySymbol?.toLowerCase()) ===
                                currencySymbol?.toLowerCase(),
                            )
                          : currencySymbol?.toLowerCase() === "usdc"
                            ? custodyAccounts.find(
                                (bnk) =>
                                  mng?.id?.toLowerCase() ===
                                    chainDetails[
                                      chainId
                                    ]?.spotCustodian?.toLowerCase() &&
                                  ethers.utils
                                    .parseBytes32String(bnk?.currency)
                                    ?.toLowerCase()
                                    ?.includes("usd"),
                              )
                            : filterCustodianAddress?.length > 0
                              ? custodyAccounts.find(
                                  (bnk) =>
                                    mng?.id?.toLowerCase() ===
                                      chainDetails[
                                        chainId
                                      ]?.spotCustodian?.toLowerCase() &&
                                    ethers.utils
                                      .parseBytes32String(bnk?.currency)
                                      ?.toLowerCase() ===
                                      currencySymbol?.toLowerCase(),
                                )
                              : filterCustodianAddress?.length > 0 &&
                                  currencySymbol?.toLowerCase()?.startsWith("-")
                                ? custodyAccounts.find(
                                    (bnk) =>
                                      mng?.id?.toLowerCase() ===
                                        chainDetails[
                                          chainId
                                        ]?.spotCustodian?.toLowerCase() &&
                                      ethers.utils
                                        .parseBytes32String(bnk?.currency)
                                        ?.toLowerCase()
                                        ?.includes(
                                          currencySymbol
                                            ?.toLowerCase()
                                            ?.replace("-", ""),
                                        ),
                                  )
                                : custodyAccounts.find(
                                    (bnk) =>
                                      ethers.utils
                                        .parseBytes32String(bnk?.currency)
                                        ?.toLowerCase() ===
                                      currencySymbol?.toLowerCase(),
                                  );
                    if (currencyDetails) {
                      const role = ethers.utils.parseBytes32String(mng.role);
                      if (role.toLowerCase() === "custodian") {
                        const countryCode = ethers.utils.parseBytes32String(
                          mng.country,
                        );
                        const countryDetails =
                          countries[countryCode.toUpperCase()];
                        if (
                          !custodianCountries.includes(
                            countryDetails.countryName,
                          )
                        ) {
                          custodianCountries.push(countryDetails.countryName);
                        }
                        custodians.push({
                          accountId: ethers.utils.parseBytes32String(
                            currencyDetails?.account,
                          ),
                          name: ethers.utils.parseBytes32String(
                            mng.submanager.name,
                          ),
                          address: mng.id,
                          country: countryDetails.countryName,
                          countryCode,
                          role,
                        });
                      }
                    } else {
                      return [];
                    }
                  }
                }
              }),
            );

            setData({
              custodians,
              custodianCountries,
            });
          }
        }
      } catch (err) {
        console.error("Error while fetching all custodian managers: ", err);
        setError(
          err.message ||
            "Error while fetching all custodian managers. Try again later.",
        );
      } finally {
        setLoading(false);
      }
    };

    if (Object.keys(countries).length >= 100) {
      //atleast 100 countries ??
      fetchAndFormatManagers();
    }
  }, [
    chainId,
    countries,
    currencySymbol,
    filterCountry,
    filterCustodianAddress,
    web3,
  ]);

  return {
    getCustodianDetailsData: data,
    getCustodianDetailsLoading: loading,
    getCustodianDetailsError: error,
  };
};
